import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import $ from "jquery";
import "../../css/DashBoard.css";
import "../../css/assessment.css";
import MCQ from "../questions/MCQComponent";
import TrueOrFalse from "../questions/TrueOrFalse";
import OrderComponent from "../questions/OrderComponent";
import MatchQComponent from "../questions/MatchQComponent";
import EssayComponent from "../questions/EssayComponent";
import AudioComponent from "../questions/AudioComponent";
import LabelQComponent from "../questions/LabelQComponent";
import ImageHighlightComponent from "../questions/ImageHighlightComponent";
import FileUploadEnhanced from "../questions/FileUploadEnhanced";
import FillTheBlank from "../questions/FillTheBlank";
import VideoComponent from "../questions/VideoComponent";
import "react-responsive-modal/styles.css";

import Swal from "sweetalert2";
import jwt_decode from "jwt-decode";

import ProcessCardSingleState from "../questions/ProcessCardSingleState";
import { MathJax } from "better-react-mathjax";
import axios from "axios";
import { BASE_URL } from "../../variables/api";
import Cookies from "js-cookie";

const assessmentComponent = () => {
  const [state, setState] = useState<any>({
    assessment: null,
    questions: [],
  });
  const user = useSelector((storeState: any) => storeState.user);

  const history = useHistory();
  let userName = ""
  let quiztoken: any = Cookies.get("quiztoken");
  if (quiztoken) {
    let decodedToken: any = jwt_decode(quiztoken || "");
    userName = decodedToken.data.userName;
  } 

  const searchParams: any = new URLSearchParams(location.search);
  const encryptedMode = searchParams.get("exammode");
  let examMode =
    encryptedMode == "MSTMG" ? "gradingModeStudent" : encryptedMode;
  const id = searchParams.get("id");
  const version = searchParams.get("v");
  useEffect(() => {
    $("#preloader").hide();
    if (examMode == "gradingModeTeacher") {
      GradingAssessment(id);
    } else if (examMode == "gradingModeStudent") {
      GetGradedExam(id);
    } else {
      ViewAssessment(id, version);
    }
  }, []);

  const GradingAssessment = (id: any) => {
    axios
      .post(BASE_URL + "admin/getstudentsol.php", {
        id: id,
      })
      .then((res: any) => {
        console.log("res", res.data.data);
        setState((x: any) => ({
          ...x,
          assessment: res.data.data,
          questions: res.data.data.answeredquestions,
        }));
      })
      .catch((err: any) => { });
  };

  const GetGradedExam = (id: any) => {
    axios
      .post(BASE_URL + "admin/getgradedexam.php", {
        id: id,
      })

      .then((res: any) => {
        console.log("res", res.data.data);
        if (res.data.data.status.toLowerCase() != "graded" && examMode == "gradingModeStudent") {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "This exam has not been graded yet.",
          });
          return;
        }
        setState((x: any) => ({
          ...x,
          assessment: res.data.data,
          questions: res.data.data.answeredquestions,
        }));
      })
      .catch((err: any) => { });
  };

  const ViewAssessment = (id: any, version: any) => {
    axios
      .post(BASE_URL + "admin/getexam.php", {
        id: id,
        version: version,
      })
      .then((res: any) => {
        setState((x: any) => ({
          ...x,
          assessment: res.data.data,
          questions: res.data.data.questions,
        }));
      })
      .catch((err: any) => { });
  };

  const onCloseModal = (Q: any = null) => {
    // save q in array in the store

    setState((x: any) => ({ ...x, open: false }));
  };
  const onSaveQuestion = (question: any) => {
    let tempQuestins = [...state.questions];
    let q = tempQuestins.find((q: any) => q.id == question.id);
    if (q) {
      let questions = [...tempQuestins];
      let index = questions.indexOf(q);
      questions[index] = question;

      setState((x: any) => ({ ...x, questions: questions }));
    }
  };

  const submitExam = () => {
    const data = {
      id: state.assessment?.id,
      questions: state.questions,
    };

    axios
      .post(BASE_URL + "admin/gradeexam.php", data)
      .then((res: any) => {
       
       
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.msg,
          didOpen: () => {
            const okButton = Swal.getConfirmButton();
            if (okButton) {
              okButton.id = "examOkButtonId";
            }
          },
          allowOutsideClick: false,
          showConfirmButton: !user.isExternalUser,
        }).then(() => {
          onConfirm(state.assessment?.exam_id);
        });
      })
      .catch((err: any) => { });
  };

  const handleBackClick = (id: any) => {
    if (id === undefined) {
      history.push({
        pathname: `/dashboard/assessments/${id}`,
      });
    } else {
      history.push({
        pathname: `/dashboard/StudentsExams/${id}`,
      });
    }
  };

  const editQuestionsRenderer = (s: any, q: any, index: any) => {
    q.mode = examMode;
    switch (s) {
      case "MCQ":
        return (
          <MCQ
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "OrderComponent":
        return (
          <OrderComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "MatchQComponent":
        return (
          <MatchQComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "ProcessCard":
        return (
          <ProcessCardSingleState
            type={"ProcessCard"}
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "ProductCard":
        return (
          <ProcessCardSingleState
            type={"ProductCard"}
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "LabelQComponent":
        return (
          <LabelQComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "TrueOrFalse":
        return (
          <TrueOrFalse
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "EssayComponent":
        return (
          <EssayComponent
            quest={q}
            index={index}
            etype ={state.assessment?.etype}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "VideoComponent":
        return (
          <VideoComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "AudioComponent":
        return (
          <AudioComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "FileUploadEnhanced":
        return (
          <FileUploadEnhanced
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "FillTheBlank":
        return (
          <FillTheBlank
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      case "ImageHighlight":
        return (
          <ImageHighlightComponent
            quest={q}
            index={index}
            passage={state.assessment?.passages?.find(
              (p: any) => p.id == q.passage_id
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );

      default:
    }
  };
  const onConfirm = (exam_id: any) => {
    if (examMode == "examMode") {
      history.push("/dashboard/assessments");
    } else if (examMode == "gradingModeTeacher") {
      history.push({
        pathname: `/dashboard/StudentsExams/${exam_id}`,
      });
    }
  };

  console.log("examMode", examMode);
  console.log("questions", state.questions);
  return (
    <MathJax>
      <div>
        <div className=" d-flex d-md-block flex-nowrap wrapper ">
          <div className="col-md-9 float-center mx-auto pl-md-2 pt-2 main">
            <div>
              <div className="col-12 mx-auto align-items-center bg-question rounded p-3 text-white">
                <div className="row"></div>
                {examMode == "gradingModeTeacher" && (
                  <button
                    id="backbuttonID"
                    onClick={(e: any) => {
                      if (user?.isExternalUser) {
                        e.preventDefault(); 
                      } else {
                        handleBackClick(state.assessment.exam_id);
                       
                      }
                    }}
                    className="btn btn-secondary mb-3"
                  >
                    <i className="fa fa-arrow-left" aria-hidden="true" />
                
                  </button>
                )}

                <div className="mt-4 ml-3"></div>

                <div id="printableDiv">
                  <h3 className="text-shadow mt-2 ml-3">Questions : </h3>
                  {state.questions?.map((q: any, index: number) => {
                    return (
                      <React.Fragment key={index}>
                        {editQuestionsRenderer(q.type, q, index + 1)}
                      </React.Fragment>
                    );
                  })}
                </div>
                {examMode == "gradingModeTeacher" && (
                  <div className="text-center mt-5 ">
                    <button
                      className="btn btn-warning text-white"
                      onClick={submitExam}
                    >
                      Save Grading
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MathJax>
  );
};

export default assessmentComponent;
